import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, PLATFORM_ID, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AnalyticsService } from './../../services/analytics.service';

import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { EventService } from '../../services/event.service';
import { CHAINS } from '../../shared/constants/app-enums';
import { allLanguages } from '../../shared/constants/languages';
import { ILanguage } from '../../shared/interfaces/wallet.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('navigation') navigation!: ElementRef;
  private subscriptions: Subscription[] = [];
  public walletAddress: string = ""
  isScrolled: boolean = false;
  showMenu: boolean = false;
  openMenu: boolean = false;
  modalRef?: BsModalRef;
  hashKey: string = '';
  server: string = environment.server;
  currentLanguage = '';
  languagesList = allLanguages;
  selectedLanguage: ILanguage = {} as ILanguage;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isScrolled = window.pageYOffset >= 50;
  }

  navigations = [
    {
      routeName: 'home',
      navName: 'top_navigation.nav_home',
    },
    {
      routeName: 'about',
      navName: 'top_navigation.nav_about',
    },
    {
      routeName: 'tokenomics',
      navName: 'top_navigation.nav_tokenomics',
    },
    {
      routeName: 'how-to-buy',
      navName: 'top_navigation.nav_howtobuy',
    },
    {
      routeName: 'roadmap',
      navName: 'top_navigation.nav_roadmap',
    },

    {
      routeName: 'faq',
      navName: 'top_navigation.nav_faq',
    },
  ];

  social = [
    {
      img: 'assets/images/svg-icons/social-icons/twitter.svg',
      alt: 'Twitter',
      link: 'https://x.com/qeltblockchain',
    },
    {
      img: 'assets/images/svg-icons/social-icons/telegram.svg',
      alt: 'Telegram',
      link: 'https://t.me/QXMPLabs',
    },
  ];

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private eventService: EventService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private dataService: PresaleDataService,
    private analyticsService: AnalyticsService
  ) {
    this.subscriptions.push(this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      // console.log('LangChangeEvent called in header', params.lang);
      this.currentLanguage = params.lang;
      this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      if (isPlatformBrowser(this._platformId)) localStorage.setItem('lang', this.currentLanguage);
    }));

    this.activatedRoute.fragment.subscribe(fragment => {
      this.hashKey = fragment ?? '';
    });
    this.dataService.$walletAddress.subscribe((item) => {
      this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress
    })
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this._platformId)) {
      if (!this.currentLanguage) {
        this.currentLanguage = localStorage.getItem('lang') || 'en';
        this.selectedLanguage = this.languagesList.filter((x) => x.value === this.currentLanguage)[0];
      }

      const pathName = window.location.pathname.split('/')[2] || window.location.pathname.split('/')[1] || '';
      this.hashKey = window.location.hash ? window.location.hash.substring(1, window.location.hash.length) : '';
      // console.log('/npathName =', pathName, '/nhashKey =',this.hashKey)
      setTimeout(() => this.addActive(this.navigation.nativeElement, pathName, true), 1000);
    }
  }

  addActive(event: Event, section: string, autoMode: boolean = false) {
    if (!autoMode) this.hashKey = section && section != 'staking' ? section : '';
    const target: HTMLElement = event.currentTarget ? (event.currentTarget as HTMLElement) : (event.target as HTMLElement);
    let linkList = target.parentNode?.querySelectorAll('a') || [];
    linkList.forEach((link: HTMLAnchorElement) => {
      if (link === event.target || link.title === this.hashKey) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  showWidget(section: string): void {
    this.analyticsService.vwoData('walletConnectionPlacement', { placement: 'Navbar' });
    if (window.location.pathname.includes('dashboard')) {
      window.scroll({ top: 0 });
      this.connectModal();
    } else {
      this.eventService.showBuyWidget(section);
      setTimeout(() => {
        this.dataService.connectWallet();
      }, 1000);
    }
  }

  connectModal(): void {
    this.dataService.connectWallet();
  }

  disconnect(): void {
    this.dataService.disconnectWallet();
  }

  openCloseMenu(): void {
    if (this.showMenu) {
      this.openMenu = !this.openMenu;
      document.body.classList.remove('modal-open');
      setTimeout(() => (this.showMenu = !this.showMenu), 600);
    } else {
      this.showMenu = !this.showMenu;
      document.body.classList.add('modal-open');
      setTimeout(() => (this.openMenu = !this.openMenu), 300);
    }
  }

  vwoData(socialName: string): void {
    this.analyticsService.vwoData('socials', { clickedXButton: socialName === 'Twitter', clickedTelegramButton: socialName === 'Telegram' });
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
